import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogInner,
  DialogHeader,
  DialogContent,
  DialogFooter
} from "../../../Common/UI/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import { INotification } from "../../../Notification/Index";
import { DetailsTabView } from "./DetailsTab.View";

interface CreateConfigViewProps {
  /**
   * Flag to show the dialog
   */
  showDialog: boolean;
  /**
   * Close handler for the dialog
   */
  onClose: () => void;
  /**
   * Close handler for the dialog
   */
  onSave: () => void;
  /**
   * Name of the config
   */
  configName: string;
  /**
   * Name of the file
   */
  fileName: string;
  notificationItems: INotification[];
}

/**
 * Responsible for rendering the Create Config UI
 * @returns Create Config view component
 */
export const CreateConfigView: React.FC<CreateConfigViewProps> = (props: CreateConfigViewProps): JSX.Element => {
  const {
    showDialog,
    onClose,
    onSave,
    configName,
    fileName,
    notificationItems
  } = props;
  const { t: translate } = useTranslation();

  return (
    <div id="ebt-outputConfig-config-createConfig">
      {showDialog &&
        <Dialog
          open={showDialog}
          onOpenChange={onClose}
          preventBackdropClose={true}
          className="ebt-outputConfig-config-createConfig"
        >
          <DialogInner className="ebt-outputConfig-config-createConfig-inner">
            <DialogHeader>
              <div>
                {translate("OutputConfig.CreateDialog.Title")}
              </div>
            </DialogHeader>
            <DialogContent>
              {
                showDialog ?
                  <DetailsTabView
                    isDetailsTab={false}
                    notificationItems={notificationItems}
                    isSaveButtonClick={false}
                  /> :
                  null
              }
            </DialogContent>
            <DialogFooter>
              <ButtonGroup>
                <Button
                  borderless={true}
                  onClick={onClose}
                  id="ebt-outputConfig-config-createConfig-cancel-btn"
                >
                  {translate("Button.Cancel")}
                </Button>
                <Button
                  variant={ButtonVariantType.FILLED}
                  onClick={onSave}
                  disabled={!(Boolean(configName) && Boolean(fileName))}
                  id="ebt-outputConfig-config-createConfig-save-btn"
                >
                  {translate("Button.Save")}
                </Button>
              </ButtonGroup>
            </DialogFooter>
          </DialogInner>
        </Dialog>
      }
    </div>
  );
};
